import {contarWheres} from "../../Servicios/BD/Contadores/contarWheres";
import {where} from "firebase/firestore";

export const obtenerNumProgramas = (datos) => {

    if (!datos) {
        return 0
    }

    let id = datos.id;
    if (!id) return 0


    let wheres = [where('idEscuela', '==', id)]
    contarWheres({coleccion: 'programas', wheres: wheres}).then((res) => {
        return res.data
    })


}